import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/style.scss'
import { Route, Routes, BrowserRouter } from "react-router-dom"
import React, { useState, useEffect } from 'react'
import { SnackbarProvider } from 'notistack';
import PlayerDashboard from "./views/player/Dashboard";
import PlayerFedback from "./views/player/Feedback";
import 'bootstrap-icons/font/bootstrap-icons.css';

import AdminDashboard from "./views/admin/Dashboard";
import Login from "./views/auth/login";
import Home from "./views/Home"
import Logout from './views/auth/Logout';
import Register from "./views/auth/register";
import SportSelection from './views/auth/SportSelection';
// import ChangeTeamModal from './views/modal/ChangeTeamModal';
import ChangeTeamModal from './views/modal/TestTeamModal';

import Gameplan from './views/auth/GamePlan';

import NewPassword from './views/auth/newPassword';
import OtpVerfication from './views/auth/OtpVerification';
import ForgotPassword from './views/auth/ForgotPassword';
import Profile from './views/Profile';
import NotFound from './views/NotFound';
import Redirect from './views/Redirect';
import AdminLayout from './layouts/AdminLayout';
import ScorerLayout from './layouts/ScorerLayout';
import ParticipantLayout from './layouts/ParticipantLayout';
import { useSelector } from 'react-redux';

// admin imports
import Tournaments from './views/admin/Schedule/Tournament/Tournaments';
import CreateTournament from './views/admin/Schedule/Tournament/Create';

import Groups from './views/admin/Schedule/Groups/Index';

import Matches from './views/admin/Schedule/Match/Index';

import Knockout from './views/admin/Schedule/Knockout/Index';

import Corporates from './views/admin/Manage/Corporate/Corporates';
import CreateCorporates from './views/admin/Manage/Corporate/Create';

import Users from './views/admin/Manage/User/List';
import SenEmailUser from './views/admin/Manage/User/SendEmail';

import CreateUser from './views/admin/Manage/User/Create';
import DeleteUser from './views/admin/Manage/User/Delete';
import DetailUser from './views/admin/Manage/User/Detail'
import Settings from './views/admin/settings/index'
import Config from './views/admin/settings/Config'
import Faq from './views/admin/settings/Faq'
import CreateFaq from './views/admin/settings/CreateFaq'
import CreateGallery from './views/admin/settings/CreateGallery'
import Gallery from './views/admin/settings/Gallery'



import Withdrwal_Waiting from './views/admin/Withdrwal&Waiting/index';
import Documents from './views/admin/settings/document'
import CreateDocument from './views/admin/settings/Create';
import Standing from './views/Standing';
import PGallery from './views/PGallery';
import PrivacyPolicy from './views/PrivacyPolicy';
import TermsandCondition from './views/TermsandCondition';
import Contact from './views/Contact';
import Faq_user from './views/Faq_user';

import ScorerDashboard from './views/scorer/Home'
import DynamicText from './views/admin/settings/DynamicText';
import CreateDynamicText from './views/admin/settings/CreateDynamicText';
import ContentManagment from './views/admin/settings/ContentManagement';
import ContentManagmentCreate from './views/admin/settings/ContentManageCreate';
import Loader from './views/admin/Common/AppLoader';



function App() {

	var currentRoute = window.location.pathname;
	const user_data = useSelector((state) => state.user);
	const user_role = localStorage.getItem('role');
	const [role, setRole] = useState(user_role);
	const page_routes = ['/login', '/register', '/forgot-password', '/verification', '/', '/Results', '/photo-gallery','/contact' , '/terms&condition' ,'/privacy&policy'];
	const allRoutes = [
		'/', 
		'/login', 
		'/logout', 
		'/register', 
		'/new-password/:token', 
		'/verification', 
		'/forgot-password', 
		'/profile', 
		'/Results', 
		'/photo-gallery', 
		'/privacy&policy', 
		'/terms&condition', 
		'/contact',
		'/dashboard',
		'/admin/profile',
		'/tournaments',
		'/tournament/create',
		'/tournament/edit',
		'/groups',
		'/knockout',
		'/matches',
		'/teams',
		'/teams/create',
		'/teams/edit',
		'/content_management',
		'/content_management/edit',
		'/users',
		'/send-mail',
		'user/create',
		'user/delete',
		'user/edit',
		'user/detail',
		'/payment_details',
		'/documents',
		'/documents/create',
		'/manage',
		'/config',
		'/faqs',
		'/faq',
		'/faq/create',
		'faq/edit',
		'/dynamic_text',
		'/dynamic_text/create',
		'/dynamic_text/edit',
		'/gallery',
		'/gallery/create',
		'/gallery/edit',
		'/scorer/profile',
		'/participant/profile',
		'/participant/feedback',
		'/select-sport',
		'/game-plan',
		'/Results'

	  ];
	  
	const user_token = localStorage.getItem('token');
	const [loaderStatus, setLoaderStatus] = useState(true);
	const [IsRedirect, setIsRedirect] = useState(false);
	const [RedirectUrl, setRedirectUrl] = useState('/dashboard');

	const callback = () => {
		setIsRedirect(false);
	}

		useEffect(() => {
			setLoaderStatus(true);
			const substring = '/new-password/';
			if (currentRoute.includes(substring)) {
				page_routes.push(currentRoute);
			}

			if (user_data != undefined && user_data != null && user_data.role != undefined || user_role != undefined && user_role != null) {
				setRole(user_data != undefined && user_data.role != undefined ? user_data.role : user_role)
			}	
			if (currentRoute === '/' || currentRoute === '/Results' || currentRoute === '/photo-gallery' || currentRoute === '/contact' || currentRoute === '/photo-gallery'  || currentRoute === '/terms&condition'  || currentRoute === '/privacy&policy' || currentRoute === '/faqs') {
				setIsRedirect(false);
			} else {
				if (user_token && page_routes.includes(currentRoute)) {
					setRedirectUrl('/dashboard');
					setIsRedirect(true);
				}

				if (!user_token && !page_routes.includes(currentRoute)) {
					const url = new URL(window.location.href);
					const pathname = url.pathname;
					const search = url.search;
					currentRoute = `${pathname}${search}`;
					console.log(currentRoute)
					if (allRoutes.includes(pathname)) {
						setRedirectUrl(`/login?redirect=${encodeURIComponent(currentRoute)}`);
						setIsRedirect(true);
					  }
					
				}
			}
			
			setLoaderStatus(false);

		}, [user_data, setRole]);

	return (
		<SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
			{loaderStatus ? <Loader /> : null}
			<BrowserRouter>
				{
					IsRedirect ? <Routes><Route path="*" element={<Redirect url={RedirectUrl} callback={callback} />} /></Routes> :
					// role !== '' ?(

						<Routes>
							{
								role == 'admin' ?
									<Route element={<AdminLayout />} >
										{/* <Route path ='/path' element={<element/>} ></Route> */}
										<Route exact path='/dashboard' element={<AdminDashboard />} ></Route>
										<Route path='/admin/profile' element={<Profile />} ></Route>

										<Route path='/admin/dashboard' element={<AdminDashboard />} ></Route>
										<Route path='/tournaments' element={<Tournaments />} ></Route>
										<Route path='/tournament/create' element={<CreateTournament />} ></Route>
										<Route path='/tournament/edit' element={<CreateTournament />} ></Route>

										<Route path='/groups' element={<Groups />} ></Route>
										<Route path='/groups_bowling' exact element={<Groups />} ></Route>

										<Route path='/groups_2k' exact element={<Groups />} ></Route>


										<Route path='/knockout' element={<Knockout />} ></Route>

										<Route path='/matches' element={<Matches />} ></Route>

										<Route path='teams' element={<Corporates />} ></Route>
										<Route path='/teams/create' element={<CreateCorporates />} ></Route>
										<Route path='/teams/edit' element={<CreateCorporates />} ></Route>
										<Route path='/content_management' element={<ContentManagment />} ></Route>
										<Route path='/content_management/edit' element={<ContentManagmentCreate />} ></Route>


								<Route path ='/users' element={<Users/>} ></Route>
								<Route path ='/send-mail' element={<SenEmailUser/>} ></Route>
								<Route path ='user/create' element={<CreateUser/>} ></Route>
								<Route path ='user/delete' element={<DeleteUser/>} ></Route>
								<Route path ='user/edit' element={<CreateUser/>} ></Route>
								<Route path ='user/detail' element={<DetailUser/>} ></Route>
								<Route path='/payment_details' element={<Settings />} ></Route>
								<Route path='/documents' element={<Documents />} ></Route>
								<Route path='/documents/create' element={<CreateDocument />} ></Route>
								<Route path='/manage' element={<Withdrwal_Waiting />} ></Route>
								<Route path='/config' element={<Config />} ></Route>
								<Route path='/faq' element={<Faq />} ></Route>
								<Route path='/faq/create' element={<CreateFaq />} ></Route>
								<Route path ='faq/edit' element={<CreateFaq/>} ></Route>
								
								<Route path='/dynamic_text' element={<DynamicText />} ></Route>
								<Route path='/dynamic_text/create' element={<CreateDynamicText />} ></Route>
								<Route path='/dynamic_text/edit' element={<CreateDynamicText />} ></Route>



								<Route path ='/gallery' element={<Gallery/>} ></Route>
								<Route path ='/gallery/create' element={<CreateGallery/>} ></Route>
								<Route path ='/gallery/edit' element={<CreateGallery/>} ></Route>








									</Route>
									:
									role == 'scorer' ?
										<Route element={<ScorerLayout />} >
											{/* <Route path ='/path' element={<element/>} ></Route> */}
											<Route exact path='/dashboard' element={<ScorerDashboard />} ></Route>
											<Route path='/scorer/profile' element={<Profile />} ></Route>
										</Route>
										: role == 'participant' ? <>
											<Route element={<ParticipantLayout />} >
												{/* <Route path ='/path' element={<element/>} ></Route> */}
												<Route exact path='/dashboard' element={<PlayerDashboard />} ></Route>
												<Route path='/participant/profile' element={<Profile />} ></Route>
												<Route path='/participant/feedback' element={<PlayerFedback />} ></Route>

											</Route>
											<Route path='/select-sport' element={<SportSelection />} ></Route>
											<Route path='/game-plan' element={<Gameplan />} ></Route>
											<Route path='/test' element={<ChangeTeamModal />} ></Route>



										</> : null


							}
							{/* common routes */}
							<Route path='/' element={<Home />} ></Route>
							<Route path='/login' element={<Login />} ></Route>
							<Route exact path='/logout' element={<Logout />} ></Route>
							<Route path='/register' element={<Register />} ></Route>
							{/* <Route exact path='/new-password/token/:token' element={<NewPassword />} ></Route> */}
							<Route exact path='/new-password/id/:id/token/:token' element={<NewPassword />} />
							<Route path='/verification' element={<OtpVerfication />} ></Route>
							<Route path='/forgot-password' element={<ForgotPassword />} ></Route>
							<Route path='/profile' element={<Profile />} ></Route>
							<Route path='/Results' element={<Standing />} ></Route>
							<Route path='/photo-gallery' element={<PGallery />} ></Route>
							<Route path='/privacy&policy' element={<PrivacyPolicy />} ></Route>
							<Route path='/terms&condition' element={<TermsandCondition />} ></Route>
							<Route path='/contact' element={<Contact />} ></Route>
							<Route path='/faqs' element={<Faq_user />} ></Route>
							
							<Route path="*" element={<NotFound />} />

							{/* admin routes */}
							<Route element={<AdminLayout />} >

							</Route>
							{/* participant routes */}
							<Route element={<ParticipantLayout />} >
								{/* <Route exact path ='/participant/dashboard' element={<PlayerDashboard/>} ></Route> */}
							</Route>
						</Routes>
					// ): (
					// 	<Loader /> // Show a loading state until role is determined
                    // )
				}
			</BrowserRouter>
		</SnackbarProvider>
	);
}

export default App;
